module.exports = __webpack_public_path__ + "brazil.svg?a102e5631626f71ddbc427003063dc0a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/brazil.svg
// module id = 117
// module chunks = 10